import { render } from "./ChooseSystem.vue?vue&type=template&id=96f11628&scoped=true"
import script from "./ChooseSystem.vue?vue&type=script&lang=js"
export * from "./ChooseSystem.vue?vue&type=script&lang=js"

import "./ChooseSystem.vue?vue&type=style&index=0&id=96f11628&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f11628"]])

export default __exports__